import {useRef, useState} from 'react';
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {reportsApi} from '../api/reports.api';
import {useReportError} from '../hooks/use-report-error';
import {DeleteReportDialogProps} from '../types/report-list.types';

export const DeleteReportDialog = ({report, onClose, onDeleted}: DeleteReportDialogProps) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const inFlight = useRef(false);
  const reportError = useReportError();
  const remove = async () => {
    if (!report || inFlight.current) return;
    inFlight.current = true;
    setBusy(true);
    setError('');
    try {
      await reportsApi.remove(report.id);
      onDeleted();
    } catch (error) {
      setError((await reportError(error, 'Не удалось удалить отчёт. Попробуйте ещё раз.')).message);
    } finally {
      inFlight.current = false;
      setBusy(false);
    }
  };
  return (
    <Dialog
      open={Boolean(report)}
      onClose={busy ? undefined : onClose}
      aria-labelledby="delete-report-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="delete-report-title">Удалить отчёт?</DialogTitle>
      <DialogContent>
        <DialogContentText>Отчёт «{report?.name}» будет удалён.</DialogContentText>
        {error && (
          <Alert severity="error" sx={{mt: 2}}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Отмена
        </Button>
        <Button onClick={remove} color="error" variant="contained" disabled={busy}>
          {busy ? 'Удаление…' : 'Удалить'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
